import { FormInstance } from "antd";
import { useCallback, useEffect } from "react";
import ReportService from "../../../../../../../../../services/reportGeneration";
import { useAttachmentTools } from "../../../../../../../../../lib/hooks/useAttachmentTools";
import { TPrintData } from "../../../types";
import { useGetTaskGenerateReport } from "../../../../../../../../../lib/hooks/useGetTaskStatus";

export const useGenerateAttachment = (
  form: FormInstance,
  itemToPrint: TPrintData,
  setGlobalIsLoading: (value: boolean) => void
) => {
  const { setError, onFail } = useAttachmentTools(form, setGlobalIsLoading);

  const { getStatus } = useGetTaskGenerateReport(
    form,
    setGlobalIsLoading,
    setError,
    onFail
  );

  const generate = useCallback(async () => {
    if (itemToPrint) {
      setError([]);

      const reportId: string = await Promise.resolve(
        ReportService.generateReportByName("PayoffQuoteReport", {
          id: itemToPrint.id,
        })
      );

      await getStatus(reportId);
    }
  }, [itemToPrint, setError, getStatus]);

  useEffect(() => {
    generate();
  }, [generate]);
};
